import { createContext } from 'react';

type Props = {
  onEncounterClick?: (globalPatientId: string) => void;
};

const AppointmentsContext = createContext<Props>({});

export default AppointmentsContext;
